export enum GameProviderEnum {
  DreamGaming = 'dream-gaming',
  Ebet = 'ebet',
  EvolutionGaming = 'evolution-gaming',
  VivoGaming = 'vivo-gaming',
  Yeebet = 'yeebet',
  Hogaming = 'hogaming',
  JDB = 'jdb',
  Microgaming = 'microgaming',
  Evoplay = 'evoplay',
  Evolution = 'evolution',
  PGsoft = 'pgsoft',
  CQ9 = 'cq9',
  PlaynGo = 'playngo',
  B52 = 'b52',
  HitClub = 'hitclub',
  Rikvip = 'rikvip',
  GO88 = 'go88',
  TechPlay = 'techplay',
  Spribe = 'spribe',
  Pragmatic = 'pragmatic',
  Ezugi = 'ezugi',
  QTech = 'qtech',
  Habanero = 'habanero',
  Redtiger = 'redtiger',
  Netent = 'netent',
  Jili = 'jili',
  Fachai = 'fachai',
  Ws168 = 'ws168',
  Ga28 = 'ga28',
  Sunwin = 'sunwin',
  '789club' = '789club'
}

export enum GameCategoryEnum {
  SLOTS = 'slots',
  FISHING = 'fishing',
  CARD_GAME = 'game-bai',
  NO_HU = 'no-hu',
  TABLE_GAMES = 'table-games',
  LOTTERY = 'lottery',
  BAN_CA = 'ban-ca',
  LO_DE = 'lo-de',
  QUAY_SO = 'quay-so',
  INSTANT_GAMES = 'instant-games',
  BATTLE_GAMES = 'battle',
  OTHER = 'other',
  IN_GAME = 'in-game',
  DAU_TRI = 'dau-tri',
}

export enum GameTypeEnum {
  GP_URL = 'gp_url',
  SPRIBE = 'spribe',
  SPRIBE_GAMING = 'spribe-games',
  INSTANT_GAMES_URL = 'instant_games_url',
  PG_URL = 'pg_url',
  GAME_BAI_URL = 'gamebai_url',
}

export enum CasinoProviderEnum {
  DREAM_GAMING = 'dream_gaming',
  SA_GAMING = 'sa_gaming',
  VIVO_GAMING = 'vivo-gaming',
  SEXY_CASINO = 'sexy-casino',
  EZUGI = 'ezugi',
  EVOLUTION_GAMING = 'evolution-gaming',
  EVOLUTION = 'evolution',
  VIVO_CASINO = 'vivo-casino',
  VIVO_SEXY = 'vivo-sexy',
  VIVO = 'vivo',
  EBET = 'ebet',
}

export enum IFrameGameURLEnum {
  VIRTUAL_SPORTS = '/vsport',
  ESPORTS = '/esports',
  LIVE_CASINO = '/casino',
  VIRTUAL_GAME = '/virtualgame',
  SABA_CLUB = '/saba-club',
  NUMBER_GAME = '/numbergame',
  TP_NUMBER_GAME = '/tp-numbergame',
  KENO = '/keno',
  TP_KENO = '/tp-keno',
  LOTTERY = '/lottery',
  LOTTERY_LAS_VEGAS = '/quayso-disco',
  LOTTERY_CYBER_PUNK = '/lottery-cyber-punk',
  TABLE_GAMES = '/tablegame',
  LODE = '/lo-de-3-mien',
  LODE_SIEUTOC = '/lo-de-sieu-toc',
  LODE_DAICAT = '/lo-de-dai-cat',
  LODE_AO = '/lo-de-ao',
  T_SPORTS = '/play-t-sport-game',
  C_SPORTS = '/play-sport-game',
  I_SPORTS = '/play-isport-game',
  M_SPORTS = '/play-americas-sport-game',
  P_SPORTS = '/play-europe-sport-game',
  K_SPORTS = '/play-k-sport-game',
  V_GAMING = '/vgaming',
  VIRTUAL_CASINO = '/song-bai-ao',
  QUAYSO_ATOM = '/quayso-atom',
  KENO_VIETLOT = '/keno-vietlott',
  NUMBER_GAME_5_URL = '/numbergame-5'
}

export enum SportProvider {
  M_SPORTS = 'im-sports',
  K_SPORTS = 'k-sports',
  P_SPORTS = 'bti-sports',
  C_SPORTS = 'athena-sports',
  I_SPORTS = 'i-sports',
  E_SPORTS = 'athena-e-sports',
  V_SPORTS = 'athena-virtual-sports',
}

export enum PlayGameSchemeEnum {
  Url = 'url',
  Html = 'html',
}
